module.exports = __webpack_public_path__ + "img/37_150.a1473a52.png";